import get from 'lodash/get';
import queryString, { ParseOptions } from 'query-string';

export default (state: object, options?: ParseOptions) =>
  queryString.parse(get(state, 'router.location.search', ''), options);
